import { Link } from "react-router-dom";
import { styled, Box, Typography, Avatar, Button } from "@mui/material";
import CustomDrawer from "../Drawer";

const CustomPaper = styled(Link)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "10px",
  paddingLeft: 0,
  boxShadow: "none",
  cursor: "pointer",
  textDecoration:"none"
}));

const CustomTypo = styled(Typography)(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "16px",
  lineHeight: "160%",
  letterSpacing: "0.015em",
}));

const FlexBox = styled(Box)({
  justifyContent: "flex-start",
  alignItems: "flex-start",
  display: "flex",
});

const SubTitle = styled(Typography)(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "14px",
  marginTop: "20px",
  marginBottom: "20px",
  lineHeight: "140%",
  letterSpacing: "0.015em",
  color: "#9EA3AE",
}));

const ButtonText = styled(Typography)(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: "140%",
  letterSpacing: "0.015em",
  textDecorationLine: "underline",
  color: "#2B817B",
}));

const CustomTitledPaper = styled(Box)({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "0px 0px 0px 10px",
  gap: "8px",
  width: "100%",
  height: "94px",
  background: "#F0FAF9",
  borderRadius: "4px",
});

const Title = styled(Typography)(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,
  fontStyle: "normal",
  fontWeight: 600,
  fontSize: "20px",
  letterSpacing: "0.015em",
  color: "#1A1824",
  textAlign: "center",
}));

const LightTitle = styled(Typography)(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: "160%",
  letterSpacing: "0.015em",
  color: "#9EA3AE",
}));

const MainModal = ({
  name = "Alex Ferguso",
  profileURL = "https://www.w3schools.com/howto/img_avatar.png",
  handleClose,
  handleClickTab
}) => {
  return (
    <CustomDrawer maxWidth={377} hasHeader={false} onClose={handleClose}>
      <FlexBox mt={2}>
        <Avatar
          sx={{ bgcolor: "red", width: "56px", height: "56px" }}
          variant="rounded"
          src={profileURL}
        ></Avatar>
        <Box>
          <CustomTypo marginLeft={1}>{name}</CustomTypo>
          <Button variant="text">
            <ButtonText>View Profile</ButtonText>
          </Button>
        </Box>
      </FlexBox>

      <SubTitle>Account</SubTitle>

      {[
        {
          icon: require("../../../assets/flash.png"),
          label: "My Activity",
          path: "/myactivity",
        },
        {
          icon: require("../../../assets/flash.png"),
          label: "Saved Address",
          path: "/myaddress",
        },
        {
          icon: require("../../../assets/flash.png"),
          label: "My Payments",
          path: "/mypayments",
        },
        {
          icon: require("../../../assets/flash.png"),
          label: "Favourite",
          path: "/favourite",
        },
        {
          icon: require("../../../assets/flash.png"),
          label: "Promotions",
          path: "/promotions",
        },
        {
          icon: require("../../../assets/flash.png"),
          label: "Gift Card",
          path: "/giftcard",
        },
      ].map((tab) => (
        <CustomTab
          data={tab}
          handleClick={(e) => {
            handleClickTab(e);
          }}
        />
      ))}

      <CustomPaper>
        <CustomPaperContainer
          title="Get 10% off your order"
          subTitle={"Can only be used for today"}
        />
      </CustomPaper>
      <SubTitle>Generals</SubTitle>

      {[
        {
          icon: require("../../../assets/info-circle.png"),
          label: "My Activity",
          path: "/myactivity",
        },
        {
          icon: require("../../../assets/info-circle.png"),
          label: "Saved Address",
          path: "/myaddress",
        },
        {
          icon: require("../../../assets/info-circle.png"),
          label: "Logout",
          danger: true,
          path: "/logout",
        },
      ].map((tab) => (
        <CustomTab
          data={tab}
          handleClick={(e) => {
            console.log("Path", e);
          }}
        />
      ))}
    </CustomDrawer>
  );
};

const CustomTab = ({ data, handleClick }) => {
  const { icon, label, path, danger = false } = data;
  return (
    <CustomPaper
      to={path}
    >
      <Box style={{ display: "flex", alignItems: "center" }}>
        {/* <i className={icon} style={{ marginRight: "10px" }}></i> */}
        <img src={icon} style={{ marginRight: "10px" }} />
        <CustomTypo style={{ color: danger ? "#E75C62" : "#1A1824" }}>
          {label}
        </CustomTypo>
      </Box>
      <img src={require("../../../assets/arrow-rightleft.png")} />
    </CustomPaper>
  );
};

const CustomPaperContainer = ({ title, subTitle }) => {
  return (
    <CustomTitledPaper mt={2}>
      <Box>
        <Title>{title}</Title>
        <LightTitle>{subTitle}</LightTitle>
      </Box>
      <img src={require("../../../assets/arrow-rightleft.png")} />
    </CustomTitledPaper>
  );
};

export default MainModal;
